import React from "react";
import Loadable from "react-loadable";
import { Route, Switch } from "react-router-dom";

import preloader from "../img/preloader.svg";
const style = {
  margin: "20px auto",
  display: "flex"
};
const Loading = () => <img src={preloader} alt="loading..." style={style} />;

const App = Loadable({
  loader: () => import(/* webpackChunkName: "home"*/ "../App"),
  loading: () => <Loading />
});


const Tahak = Loadable({
  loader: () => import(/* webpackChunkName: "account"*/ "./tabbar/Tahak"),
  loading: () => <Loading />
});

const Warning = Loadable({
  loader: () => import(/* webpackChunkName: "explore"*/ "./tabbar/Warning"),
  loading: () => <Loading />
});

const Location = Loadable({
  loader: () => import(/* webpackChunkName: "explore"*/ "./tabbar/Location"),
  loading: () => <Loading />
});

const MainRoute = () => {

  // console.log("current_login", current_login);
  return (
    <Switch>
      
      <Route exact path="/" component={App} />
      <Route  path="/tahak" component={Tahak} />
      <Route  path="/warning" component={Warning} />
      <Route  path="/location" component={Location} />
    </Switch>
  );
};

export default MainRoute;